module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/poster-ai-988ecf75732db31b5c13f01291dc6596.png";